module.exports = __webpack_public_path__ + "img/vue.60dfaadb.svg";